// extracted by mini-css-extract-plugin
export default {"SideBarItemWrapper":"SideBarSubItem_SideBarItemWrapper__W25YC","title":"SideBarSubItem_title__BnhFx","NavLink":"SideBarSubItem_NavLink__IexxJ"};